import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import LayoutHelmet from 'yoda-site-components/lib/components/CAMNav/LayoutHelmet';
import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';

const defaultObject = {};

class MyHome extends Component {
    static defaultProps = {
        accountDetails: {},
        userProfile: {},
    };

    static propTypes = {
        accountDetails: PropTypes.objectOf(PropTypes.object),
        actions: PropTypes.objectOf(PropTypes.func).isRequired,
        deviceType: PropTypes.objectOf(PropTypes.object).isRequired,
        userProfile: PropTypes.objectOf(PropTypes.object),
    };

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount() {
        if (!__SERVER__ && this.props.deviceType && this.props.deviceType.isMobile) {
            window.location.assign('/account/dashboard?showNavPanel=true');
        }
    }

    componentDidMount() {
        if (this.props.accountDetails && this.props.accountDetails.profile) {
            const rewardsTier = TokenProvider.get('DP_REWARDS_TIER');
            const rewardsStatus = TokenProvider.get('DP_REWARDS_STATUS');
            const analyticsData = {
                trackEvent: 'digitalDataReady',
                status: rewardsStatus,
                rewardsTier,
                pageName: 'CAM Dashboard',
            };
            this.props.actions.camAnalyticsAction(analyticsData);
        }
    }

    render() {
        const title =
            get(this.props.userProfile, 'userState', '0') !== '0' &&
            this.props.userProfile.firstName
                ? `Hi, ${this.props.userProfile.firstName}!`
                : 'My Dashboard';
        if (get(this.props.deviceType, 'isMobile')) return null;
        defaultObject.title = title;

        return <LayoutHelmet layoutState={defaultObject} />;
    }
}

export default MyHome;
